<ion-grid>
  <ion-row>
    <ion-col class="bg-tipo-classificacao-1 l-radius"></ion-col>
    <ion-col class="bg-tipo-classificacao-2"></ion-col>
    <ion-col class="bg-tipo-classificacao-3"></ion-col>
    <ion-col class="bg-tipo-classificacao-4"></ion-col>
    <ion-col class="bg-tipo-classificacao-5 r-radius"></ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <h6>BOA</h6>
      <p>0-40</p>
    </ion-col>
    <ion-col>
      <h6>MODERADA</h6>
      <p>41-80</p>
    </ion-col>
    <ion-col>
      <h6>RUIM</h6>
      <p>81-120</p>
    </ion-col>
    <ion-col>
      <h6>MUITO RUIM</h6>
      <p>121 -200</p>
    </ion-col>
    <ion-col>
      <h6>PÉSSIMA</h6>
      <p>+200</p>
    </ion-col>
  </ion-row>
</ion-grid>
